import axios from "axios";
import * as _ from "lodash";
import { useState, useContext, useEffect, useRef } from "react";
import next from "../Assets/Next.svg";
import { useNavigate } from "react-router";
import Context from "../../context/Context";
import { useUserAuth } from "../../context/UserAuthContext";
import ContestTerms from "../ContestDescripion/ContestTerms";
import ReactPlayer from "react-player";
import styles from "../UploadFormFill/UploadForm.module.css";
import Lottie from "../../Components/lottie/finalupload/finalUploadloading";
import { validate } from "../../utils/formAttributesHelper";

function UploadFormFill() {
  const [errorMessage, setErrorMessage] = useState("");

  const [participantName, setParticipantName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [email, setEmail] = useState("");
  const [description, setDescription] = useState("");
  const [address, setAddress] = useState("");

  const [uploadStart, setUploadStart] = useState(false);
  const [tc, setTc] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const inputRef = useRef();
  const [source, setSource] = useState();
  const [thumbnail, setThumbnail] = useState();
  const [thumbnailName, setThumbnailName] = useState("");
  const [showCancel, setShowCancel] = useState(false);
  const [loading, setLoading] = useState(false);
  const [placeholderText, setPlaceHolderText] = useState("");
  const {
    data,
    details,
    setUploadSucccess,
    terms,
    verifyUser,
    userIdToken,
    uploadSuccessFile,
    setUploadSucccessFile,
    pinData,
    isPrivate,
    campaignType,
  } = useContext(Context);

  const { currentUser } = useUserAuth();
  const navigate = useNavigate();
  const contestIdData = window.location.pathname.split("/")[3];
  const campaignIdData = window.location.pathname.split("/")[2];
  const organizerUniqueText = window.location.pathname.split("/")[1];
  const token = userIdToken || currentUser?.accessToken;
  const organizerMail = details?.conductedBy?.email;

  var ContentDta =
    details &&
    details.contests &&
    details.contests.find((el) => {
      return el.contestUniqueText === contestIdData;
    });

  const contestDetails = ContentDta;
  let initialValues = {
    address: "",
    participantName: "",
    email: "",
    phone: "",
    tc,
    contestName: contestDetails?.contestName,
    ageGroup: contestDetails?.ageGroup,
  };
  // let formDetails = ''
  // formDetails = {
  //   address,
  //   participantName,
  //   description,
  //   email: _.isEmpty(email) ? organizerMail : organizerMail + "," + email,
  //   phone: mobileNumber,
  //   tc: '' + tc + '',
  //   contestName: contestDetails?.contestName,
  //   ageGroup: contestDetails?.ageGroup,
  // }
  const [formDetails, setFormDetails] = useState(initialValues);
  // console.log(details);
  const campaignId = contestDetails?.campaignId;
  const contestId = contestDetails?.contestId;
  const organizerId = contestDetails?.orgId;
  const uploadedFile = pinData?.data?.data?.videoUploadURL?.split("?")[0];
  const formAttributes = contestDetails?.formAttributes;
  const orginizerName = window.location.pathname.split("/")[1];
  const campaignName = window.location.pathname.split("/")[2];

  useEffect(() => {
    verifyUser();
    // loadTermsAndConditions(orginizerName, campaignName);
    // eslint-disable-next-line
  }, [orginizerName, campaignName]);
  useEffect(() => {
    if (campaignType == "DA_PAID") {
      setPlaceHolderText("About my guru and about my choreography");
    } else if (campaignType == "MOV") {
      setPlaceHolderText("");
    }
  }, [campaignType]);
  const handleFileChange = async (event) => {
    const thumbnail = new FormData();
    const file = event.target.files[0];
    const url = URL.createObjectURL(file);
    thumbnail.append("thumbnail", file);
    setSource(url);
    setThumbnail(thumbnail);
    setThumbnailName(file.name);
  };

  const resetSource = () => {
    setSource("");
  };

  const handleChoose = async () => {
    inputRef.current.click();
  };

  const promiseUploadCall = async (e) => {
    e.preventDefault();
    if (_.isEmpty(thumbnailName) && contestDetails?.fileType === "video") {
      setErrorMessage("Please upload a thumbnail");
      return;
    }
    if (_.isEmpty(formDetails.participantName)) {
      setErrorMessage("Please enter the display name");
      return;
    }

    if (formAttributes) {
      const verifyFormAttributes = await validate(
        formAttributes,
        formDetails,
        setErrorMessage
      );
      if (verifyFormAttributes) {
        return;
      }
    }

    // if (_.get(details, "emailMandatory", "") === true || _.get(details, "emailMandatory", "") === "") {
    //   if (_.isEmpty(formDetails.email)) {
    //     setErrorMessage('Please enter a valid email')
    //     return
    //   }
    // }

    // if (_.get(details, "addressMandatory", "") === true || _.get(details, "addressMandatory", "") === "") {

    //   if (_.isEmpty(formDetails.address)) {
    //     setErrorMessage('Please enter a valid address')
    //     return
    //   }
    // }
    // if (_.get(details, "mobileMandatory", "") === true || _.get(details, "mobileMandatory", "") === "") {
    //   if (_.isEmpty(formDetails.phone)) {
    //     setErrorMessage('Please enter the mobile number')
    //     return
    //   }
    // }

    // if (_.isEmpty(mobileNumber)) {
    //   setErrorMessage('Please enter the mobile number')
    //   return
    // }
    if (!formDetails.tc) {
      setErrorMessage("Please accept the terms and conditions");
      return;
    }
    // if (_.isEmpty(formDetails.email)) {
    //   formDetails.email = `${organizerMail}`
    // } else {
    //   formDetails.email = `${organizerMail},${formDetails.email}`
    // }
    let cmpId = campaignId;
    let ctstId = contestId;
    let orgId = organizerId;

    await uploadFlow2(pinData.data.data.videoId, cmpId, ctstId, orgId);
    if (contestDetails?.fileType === "video") {
      await thubnailUpload(pinData.data.data.videoId, cmpId, ctstId, orgId);
    }
  };

  const uploadFlow2 = async (payload, cmpId, ctstId, orgId) => {
    setLoading(true);
    try {
      let config2 = {
        method: "patch",
        url: `${process.env.REACT_APP_UPLOADPATCH}/${orgId}/${cmpId}/${ctstId}/${payload}`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: formDetails,
      };
      const response2 = await axios(config2);
      setUploadSucccessFile({
        fileUrl: uploadedFile,
        orgId: organizerId,
        campaignId: campaignId,
        contestId: contestId,
        videoId: pinData.data.data.videoId,
        participantName: participantName,
        description: description,
      });
      if (contestDetails?.fileType === "image") {
        setUploadStart(true);
        setUploadSucccess(true);
        navigate(`/${organizerUniqueText}/${campaignIdData}/${contestIdData}`);
      }
      setLoading(false);

      return response2;
    } catch (error) {
      console.log(error.message);
      setLoading(false);
      navigate("error");
    }
  };
  const thubnailUpload = async (payload, cmpId, ctstId, orgId) => {
    setLoading(true);

    try {
      let config2 = {
        method: "post",
        url: `${process.env.REACT_APP_THUMNBNAILUPLOAD}/${orgId}/${cmpId}/${ctstId}/${payload}`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: thumbnail,
      };
      const response2 = await axios(config2);
      setUploadStart(true);
      setUploadSucccess(true);
      navigate(`/${organizerUniqueText}/${campaignIdData}/${contestIdData}`);
      setLoading(false);

      return response2;
    } catch (error) {
      console.log(error.message);
      navigate("error");
    }
  };
  const handleCancel = () => {
    setShowCancel(true);
  };

  return (
    <>
      {loading ? (
        <div>
          <Lottie />
        </div>
      ) : (
        <div className="text-black  flex items-center justify-center  bg-black widthController relative pb-[50px]">
          <div className="mt-[30px]">
            {uploadedFile && (
              <div className="w-[358px] min-h-[60px] rounded-[5px]  bg-[#252525] overflow-hidden text-center cursor-pointer text-white focus:outline-0 px-[15px] py-[18px] font-Inter font-[400] text-[17px] leading-[24px]">
                <div>
                  <div className=" h-[160px] overflow-hidden flex items-center justify-center mb-[5px]">
                    {contestDetails?.fileType === "video" ? (
                      <ReactPlayer
                        config={{
                          file: { attributes: { controlsList: "nodownload" } },
                        }}
                        playing={false}
                        controls={true}
                        width="100%"
                        height="100%"
                        url={uploadedFile}
                      />
                    ) : (
                      <img src={uploadedFile} className="w-auto h-[100%]" />
                    )}
                  </div>
                </div>
              </div>
            )}
            <div id="form" className="bg-black">
              {contestDetails?.fileType === "video" && (
                <div className="flex flex-col gap-[10px] mt-[20px]">
                  <label
                    htmlFor="participantName"
                    className="text-[#B5B5B5] align-items-start font-Inter font-[400] text-[17px] leading-[24px] "
                  >
                    Thumbnail (.jpeg and .jpg only){" "}
                    <span className="text-red-600">*</span>
                  </label>
                  <input
                    ref={inputRef}
                    className="hidden"
                    type="file"
                    onChange={handleFileChange}
                    accept=".jpg,.jpeg"
                  />
                  <div
                    className="w-[358px] min-h-[60px] rounded-[5px] bg-[#252525] overflow-hidden text-center cursor-pointer text-white focus:outline-0 px-[15px] py-[18px] font-Inter font-[400] text-[17px] leading-[24px]"
                    onClick={handleChoose}
                  >
                    {source ? (
                      <div>
                        <div className=" h-[160px] overflow-hidden flex items-center justify-center mb-[5px]">
                          <img src={source} className="w-auto h-[100%]" />
                        </div>
                        <p className="text-[#B5B5B5] font-Inter font-[400] text-[17px] leading-[24px] ">
                          Change Thumbnail
                        </p>
                      </div>
                    ) : (
                      "Add Thumbnail"
                    )}
                  </div>

                  <div className="w-[100%]">
                    <span className="text-[#B5B5B5]">
                      {/* Allowed file types are .jpeg and .jpg only. */}
                      Can be any image to showcase the video.
                    </span>
                  </div>
                </div>
              )}

              <div className="flex flex-col gap-[10px] mt-[20px]">
                <label
                  htmlFor="participantName"
                  className="text-[#B5B5B5] align-items-start font-Inter font-[400] text-[17px] leading-[24px] "
                >
                  Participant Display Name{" "}
                  <span className="text-red-600">*</span>
                </label>
                <input
                  type="text"
                  id="participantName"
                  name="participantName"
                  value={formDetails.participantName}
                  onChange={(e) =>
                    setFormDetails({
                      ...formDetails,
                      participantName: e.target.value,
                    })
                  }
                  className="w-[358px] h-[60px] rounded-[5px]  bg-[#B5B5B5] focus:outline-0 px-[15px] py-[18px] font-Inter font-[400] text-[17px] leading-[24px]"
                ></input>
              </div>
              {formAttributes?.map((el) => {
                if (el.attrType == "scoring") {
                  return (
                    <div className="flex flex-col gap-[10px] mt-[20px]">
                      <label className="text-[#B5B5B5] align-items-start font-Inter font-[400] text-[17px] leading-[24px] ">
                        {el.title}{" "}
                        {el.required && <span className="text-red-600">*</span>}
                      </label>
                      {el.items.map((key) => {
                        return (
                          <>
                            <h1 className="text-[#B5B5B5]">{key}</h1>
                            <input
                              type={el.type}
                              min="0"
                              value={formDetails.property}
                              onChange={(e) =>
                                setFormDetails({
                                  ...formDetails,
                                  [el.property[key]]: e.target.value,
                                })
                              }
                              className="w-[358px] h-[60px] rounded-[5px]  bg-[#B5B5B5] focus:outline-0 px-[15px] py-[18px] font-Inter font-[400] text-[17px] leading-[24px]"
                            />
                          </>
                        );
                      })}
                    </div>
                  );
                } else if (el.attrType == "prediction") {
                  return (
                    <div className="flex flex-col gap-[10px] mt-[20px]">
                      <label className="text-[#B5B5B5] align-items-start font-Inter font-[400] text-[17px] leading-[24px] ">
                        {el.title}
                        {el.required && <span className="text-red-600">*</span>}
                      </label>
                      <select
                        onChange={(e) =>
                          setFormDetails({
                            ...formDetails,
                            [el.property.key]: e.target.value,
                          })
                        }
                        className="w-[358px] h-[60px] rounded-[5px]  bg-[#B5B5B5] focus:outline-0 px-[15px] py-[18px] font-Inter font-[400] text-[17px] leading-[24px]"
                      >
                        <option selected disabled>
                          select an option
                        </option>
                        {el.items.map((key) => {
                          return (
                            <>
                              <option className="w-[358px] h-[60px] rounded-[5px]  bg-[#B5B5B5] focus:outline-0 px-[15px] py-[18px] font-Inter font-[400] text-[17px] leading-[24px]">
                                {key}
                              </option>
                            </>
                          );
                        })}
                      </select>
                    </div>
                  );
                }
              })}
              <>
                <div className="flex flex-col gap-[10px] mt-[20px]">
                  <label
                    htmlFor="description"
                    className="text-[#B5B5B5] align-items-start font-Inter font-[400] text-[17px] leading-[24px]"
                  >
                    Description
                  </label>
                  <div className="relative flex">
                    <textarea
                      type="text"
                      id="description"
                      name="description"
                      maxLength="120"
                      value={formDetails.description}
                      placeholder={placeholderText}
                      onChange={(e) =>
                        setFormDetails({
                          ...formDetails,
                          description: e.target.value,
                        })
                      }
                      className="w-[358px] h-[160px] rounded-[5px] bg-[#B5B5B5] focus:outline-0 px-[15px] py-[18px] font-Inter font-[400] text-[17px] leading-[24px]"
                    />
                    <span className="text-white w-[98%] absolute flex bottom-2 justify-end opacity-[.6]">
                      {description.length}/120
                    </span>
                  </div>
                </div>

                {/* <div className="flex flex-col gap-[10px] mt-[20px]">
                  <label
                    htmlFor="email"
                    className="text-[#B5B5B5] align-items-start font-Inter font-[400] text-[17px] leading-[24px]"
                  >
                    Email ID {(_.get(details, "emailMandatory", "") === true || _.get(details, "emailMandatory", "") === "") && <span className="text-red-600">*</span>}
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    // value={formDetails.email}
                    onChange={(e) => setFormDetails({
                      ...formDetails,
                      email: e.target.value
                    })}
                    className="w-[358px] h-[60px] rounded-[5px]  bg-[#B5B5B5] focus:outline-0 px-[15px] py-[18px] font-Inter font-[400] text-[17px] leading-[24px]"
                  ></input>
                </div> */}
                {/* <div className="flex flex-col gap-[10px] mt-[20px]">
                  <label
                    htmlFor="address"
                    className="text-[#B5B5B5] align-items-start font-Inter font-[400] text-[17px] leading-[24px]"
                  >
                    Address {(_.get(details, "addressMandatory", "") === true || _.get(details, "addressMandatory", "") === "") && <span className="text-red-600">*</span>}
                  </label>
                  <input
                    type="text"
                    id="address"
                    name="address"
                    value={formDetails.address}
                    onChange={(e) => setFormDetails({
                      ...formDetails,
                      address: e.target.value
                    })}
                    className="w-[358px] h-[60px] rounded-[5px]  bg-[#B5B5B5] focus:outline-0 px-[15px] py-[18px] font-Inter font-[400] text-[17px] leading-[24px]"
                  ></input>
                </div> */}
                {/* <div className="flex flex-col gap-[10px] mt-[20px]">
                  <label
                    htmlFor="mobileNumber"
                    className="text-[#B5B5B5] align-items-start font-Inter font-[400] text-[17px] leading-[24px]"
                  >
                    Mobile Number {(_.get(details, "mobileMandatory", "") === true || _.get(details, "mobileMandatory", "") === "") && <span className="text-red-600">*</span>}
                  </label>
                  <input
                    type="number"
                    id="mobileNumber"
                    name="mobileNumber"
                    value={formDetails.phone}
                    onInput={(e) =>
                      (e.target.value = e.target.value.slice(0, 10))
                    }
                    onChange={(e) => setFormDetails({
                      ...formDetails,
                      phone: e.target.value
                    })}
                    className="w-[358px] h-[60px] rounded-[5px]  bg-[#B5B5B5] focus:outline-0 px-[15px] py-[18px] font-Inter font-[400] text-[17px] leading-[24px]"
                  ></input>
                </div> */}
                {/* <div className="flex flex-col gap-[10px] mt-[20px]">
                  <label
                    htmlFor="ageGroup"
                    className="text-[#B5B5B5] align-items-start font-Inter font-[400] text-[17px] leading-[24px]"
                  >
                    Age group
                  </label>
                  <input
                    type="text"
                    id="ageGroup"
                    name="ageGroup"
                    required
                    value={formDetails.ageGroup}
                    readOnly
                    className="w-[358px] h-[60px] rounded-[5px]  bg-[#B5B5B5] focus:outline-0 px-[15px] py-[18px] font-Inter font-[400] text-[17px] leading-[24px]"
                  ></input>
                </div> */}
              </>

              {/* End */}
              <div className="flex  items-center justify-start   gap-[10px] mt-[25px]">
                <input
                  type="checkbox"
                  id="tc"
                  name="tc"
                  value={formDetails.tc}
                  // checked={true}
                  onClick={() =>
                    setFormDetails({
                      ...formDetails,
                      tc: !formDetails.tc,
                    })
                  }
                  className="w-[30px] h-[30px] rounded-[5px] focus:outline-none "
                ></input>
                <label
                  htmlFor="tc"
                  className="text-[#B5B5B5] font-Inter font-[400] text-[17px] leading-[24px]"
                >
                  I agree to the{" "}
                </label>
                <a
                  onClick={() => setShowTerms(true)}
                  className="text-[#B5B5B5] font-Inter font-[400] text-[17px] leading-[24px] underline  underline-offset-1 cursor-pointer"
                >
                  terms and conditions
                </a>
              </div>
              {errorMessage && (
                <p className="text-[#8B0000] text-[18px] mt-[21px]">
                  {errorMessage}
                </p>
              )}
              <div className="flex items-center justify-end   ">
                {" "}
                <button
                  className="w-[135px] h-[54px] bg-[#9e959a]  rounded-[100px] mt-[41px]  flex justify-center items-center mr-[10px]"
                  onClick={() => {
                    // navigate(`/${campaignIdData}/${contestIdData}/participate`)
                    handleCancel();
                  }}
                >
                  Cancel
                </button>
                {loading ? (
                  <button
                    disabled
                    className="w-[135px] h-[54px] bg-[#E52599]  rounded-[100px] mt-[41px]  flex justify-center items-center "
                  >
                    Uploading..
                  </button>
                ) : (
                  <button
                    onClick={promiseUploadCall}
                    type="submit"
                    className="w-[135px] h-[54px] bg-[#E52599]  rounded-[100px] mt-[41px]  flex justify-center items-center "
                  >
                    <img src={next} alt="nxt" />
                  </button>
                )}
              </div>
            </div>

            {showTerms && (
              <ContestTerms
                terms={details?.tandc}
                setShowDetails={setShowTerms}
                heading={"Terms and Conditions"}
              />
            )}
          </div>
          {showCancel && (
            <div className={styles.deteleme}>
              <p className={styles.quest}>
                Are you sure want to restart upload?
              </p>
              <p className={styles.finelConf}>You can’t undo this action.</p>
              <div className={styles.flexxx}>
                <div
                  className={styles.cancels}
                  onClick={() => setShowCancel(false)}
                >
                  <p>Cancel</p>
                </div>
                <div
                  className={styles.Deeleeete}
                  onClick={() =>
                    navigate(
                      `/${organizerUniqueText}/${campaignIdData}/${contestIdData}`
                    )
                  }
                >
                  <p>Yes</p>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default UploadFormFill;
